import React, {useEffect} from 'react';
import PackageDeliveryStatsProperties from "./PackageDeliveryStatsProperties";
import {useStyles} from "./PackageDeliveryStats.style";
import PackageDeliveryStatsStore from "./PackageDeliveryStatsStore";
import {useCommonContext} from "../../../contexts/CommonContext";
import {Observer} from "mobx-react-lite";
import clsx from "clsx";
import PageLoading from "../../../ui_components/PageLoading/PageLoading";
import {useI18nContext} from "../../../contexts/I18nContext";
import { useUserContext } from '../../../contexts/UserContext';

const PackageDeliveryStats: React.FC<PackageDeliveryStatsProperties> = ({
                                                                className = '',
                                                            }) => {

    const i18n = useI18nContext();
    const commonStore = useCommonContext();
    const userStore = useUserContext();
    const store = new PackageDeliveryStatsStore(commonStore, userStore.currentUser()?.id);
    const classes = useStyles();

    useEffect(() => {
        store.getPackageDeliveryStats();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onclick = () => {
        window.location.href = "/package-remittances";
    }

    return <Observer>{() => (
        <div className={clsx(classes.total_sales_container, classes.flex_column, className)}>
            {<div className={classes.title}>{'Servicio Paquetes'}</div>}
            <div className={clsx(classes.flex_row, classes.body)}>
                {store.packageDeliveryStats &&
                    <>
                        <div className={clsx(classes.box_container, classes.flex_column)} onClick={onclick}>
                            <div>{store.packageDeliveryStats?.deliveryAmount || 0}</div>
                            <div>Pendientes</div>
                        </div>
                    </>}
                <PageLoading className={classes.loading_container} loadingSize={40} isLoading={store.loading}
                             text={`${i18n.translate("LOADING")} ${'Artículo' || ''}`}/>
            </div>
        </div>
    )}</Observer>

}


export default PackageDeliveryStats;